import styled, { keyframes } from 'styled-components'
import { zoomIn } from 'react-animations'

import { size_2, size_4 } from '../../module/style-variables'

const animateIn = keyframes`${zoomIn}`

export const ProgressDotsContainer = styled.div`
  padding-top: ${size_2};
  padding-bottom: ${size_2};
`

export const WorkoutContainer = styled.div`
  padding: 0 ${size_4} ${size_4} ${size_4};
`

export const WorkoutInnerContainer = styled.div`
  background-color: white;
  padding: ${size_4};
  text-align: center;
`

export const WorkoutQuestionTransitionWrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100vw - 32px);
`

export const WorkoutQuestionTransition = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;
  white-space: normal;

  > * {
    white-space: normal;
  }

  &.workout-question-transition-leave {
    transform: translateX(-100%);
  }

  &.workout-question-transition-leave-active {
    transform: translateX(-210%);
    transition: ${props => `transform ${props.slideAnimationTime}ms ease`};
  }

  &.workout-question-transition-enter {
    transform: translateX(110%);
  }

  &.workout-question-transition-enter-active {
    transform: translateX(0);
    transition: ${props => `transform ${props.slideAnimationTime}ms ease`};
  }
`

export const AnimateWorkoutCompletion = styled.div`
  animation: ${props => `0.8s ${animateIn}`};
`



// WEBPACK FOOTER //
// ./src/component/Workout/Workout-styled.js